// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"KanbanContainer_wrapper__vse7h","wrapperSpinner":"KanbanContainer_wrapperSpinner__2VNL4"};